import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {
  RegistrationsAwardLeaders,
  RegistrationsAwardUnits,
  TasksRegistrationParticipants,
  TasksRemovedRegistrationParticipants
} from 'containers/pages'
import { SubTabs, SubTab } from 'components/layout'
import { meta } from 'helpers/decorators'
import { apiConfiguration } from 'helpers/decorators/api'
import { getActiveRole } from 'utils/token'
import { ROLES } from 'constants/enums'
import { ORGANIZATION_HIERARCHY } from '../../../constants/enums'
import { get } from 'lodash'

@meta({
  title: 'Registration',
  intlKey: 'pageTitle.registrations',
  dynamicProp: 'organizations.detail.name',
  dynamicPropId: 'organizations.detail.globalId'
})
@apiConfiguration()
class OrganizationRegistration extends Component {
  static propTypes = {
    activeOrganization: PropTypes.object.isRequired
  }

  render() {
    const { activeOrganization } = this.props

    const role = getActiveRole(activeOrganization)

    const hierarchyLevel = get(this.props, 'organizations.detail.hierarchyLevel.value')

    const registrationsAwardUnitsDecoFilter = hierarchyLevel === ORGANIZATION_HIERARCHY.IC.value ? 'organizationIACsRegistrations' : 'organizationAwardUnitsRegistrations'

    return (
      <SubTabs>
        <SubTab title="Award Leaders" intlKey="tabs.award_leaders">
          <RegistrationsAwardLeaders
            {...this.props}
            decoFilter="organizationLeaders"
            disablePersistedFilter
          />
        </SubTab>
        <SubTab title="Award units" intlKey="tabs.award_units">
          <RegistrationsAwardUnits
            {...this.props}
            decoFilter={registrationsAwardUnitsDecoFilter}
            disablePersistedFilter
          />
        </SubTab>
        <SubTab title="Participants" intlKey="tabs.participants">
          <TasksRegistrationParticipants
            {...this.props}
            decoFilter="organizationParticipantsRegistrations"
            disablePersistedFilter
          />
        </SubTab>
        {role === ROLES.IF_STAFF_SUPER.u && (
          <SubTab
            title="Removed Participant Registrations"
            intlKey="tabs.removed_participant_registrations"
            aside
          >
            <TasksRemovedRegistrationParticipants
              {...this.props}
              decoFilter="removedRegistrations"
              disablePersistedFilter
            />
          </SubTab>
        )}
      </SubTabs>
    )
  }
}

export default OrganizationRegistration
